import * as Yup from "yup";

export const cotizacionSchema = () => {
  return Yup.object().shape({
    name: Yup.string()
      .required("El campo es requerido")
      .trim(),
    email: Yup.string()
      .email("El email no es válido")
      .required("El campo es requerido")
      .trim(),
    phone: Yup.string()
      .required("El campo es requerido")
      .matches(/^\d{10}$/, "El campo solo admite números enteros y necesita ser de 10 dígitos")
      .trim(),
    message: Yup.string()
      .required("El campo es requerido")
      .trim()
  });
};
